/**
 * The `qps` pseudo-locale (spec §5): every catalog string accented, 40%
 * longer and bracketed, so text on screen without `⟦` is hard-coded and text
 * that clips will clip in German. Generated from the English bundle at run
 * time, through Fluent's `transform`, and never shipped as a catalog.
 */
const PLAIN = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const ACCENTS = 'àƀçðéƒĝĥîĵķĺɱñöþǫŕšţûṽŵẋýžÀƁÇÐÉƑĜĤÎĴĶĹṀÑÖÞǪŔŠŢÛṼŴẊÝŽ';

/** `<tag>` markers pass through untouched, or `<RichText>` could not find them. */
const MARKER = /(<\/?\w+>)/;

/**
 * Fluent's `transform`, applied to each text element of a pattern and never
 * to a variable's value, so what the learner typed is not pseudo-localised.
 */
export function accent(text: string): string {
  let visible = 0;
  const body = text
    .split(MARKER)
    .map((part, i) => {
      if (i % 2 === 1) return part;
      visible += part.length;
      return part.replace(/[a-zA-Z]/g, (c) => ACCENTS.charAt(PLAIN.indexOf(c)));
    })
    .join('');
  return body + '·'.repeat(Math.ceil(visible * 0.4));
}

export function bracket(text: string): string {
  return `⟦${text}⟧`;
}
